var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_google",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 20.5,
    viewBox: "0 0 20.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google\\u30ED\\u30B0\\u30A4\\u30F3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_googleg_48dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18.84,9.46a11.778,11.778,0,0,0-.186-2.1H9v3.965h5.516a4.715,4.715,0,0,1-2.045,3.094v2.572h3.313A10,10,0,0,0,18.84,9.46Z",
    transform: "translate(1.25 1.023)",
    fill: "#4285f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M10.117,19.013A9.786,9.786,0,0,0,16.9,16.529l-3.313-2.572A6.184,6.184,0,0,1,4.382,10.71H.957v2.656a10.246,10.246,0,0,0,9.16,5.647Z",
    transform: "translate(0.133 1.488)",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M4.515,11.509a6.06,6.06,0,0,1,0-3.895V4.958H1.09a10.263,10.263,0,0,0,0,9.206l3.424-2.656Z",
    transform: "translate(0 0.689)",
    fill: "#fbbc05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M10.117,4.077A5.537,5.537,0,0,1,14.035,5.61l2.94-2.94A9.851,9.851,0,0,0,10.117,0,10.246,10.246,0,0,0,.957,5.647L4.382,8.3a6.109,6.109,0,0,1,5.735-4.226Z",
    transform: "translate(0.133)",
    fill: "#ea4335",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M0,0H20.5V20.5H0Z",
    fill: "none",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo_google.48744dd9070177123380f6d3cf33be34.svg";
export { ForwardRef as ReactComponent };